export const ANALYTICS_EVENT_TYPES = {
  APP_ACCESSED: 'app-accessed',
  ASSIGNMENTS_ACCESSED: 'assignments-accessed',
  CATEGORICAL_MATERIAL_ACCESSED: 'categorical-material-accessed',
  DIGIBOOK_ACCESSED: 'digibook-accessed',
  DIGIBOOK_PAGE_ACCESSED: 'digibook-page-accessed',
  LICENSE_ACTIVATED: 'license-activated',
  LOGIN: 'login',
  MEDIALINK_ACCESSED: 'medialink-accessed',
  MODULE_ACCESSED: 'module-accessed',
  NODE_ACCESSED: 'node-accessed',
  RESULTS_ACCESSED: 'results-accessed',
  RESULTS_EXPORTED_SKORE: 'results-exported-to-skore',
  RESULTS_EXPORTED_XLSX: 'results-exported-to-xlsx',
  SEARCH_ACCESSED: 'search-accessed',
  SLIDE_SET_ACCESSED: 'slide-set-accessed',
  SLIDE_SET_CREATED: 'slide-set-created',
  SLIDE_SET_DELETED: 'slide-set-deleted',
  SLIDE_SET_DUPLICATED: 'slide-set-duplicated',
  SLIDE_SET_EDIT_MODE_ACCESSED: 'slide-set-edit-mode-accessed',
  SLIDE_SET_OVERVIEW_ACCESSED: 'slide-set-overview-accessed',
  SLIDE_SET_VIEWER_ACCESSED: 'slide-set-viewer-accessed',
  USER_MATERIAL_ACCESSED: 'user-material-accessed',
  USER_MATERIAL_CREATED: 'user-material-created',
  USER_MATERIAL_DELETED: 'user-material-deleted',
  USER_MATERIAL_COPIED: 'user-material-copied',
  USER_WHITEPAGE_ACCESSED: 'user-whitepage-accessed',
  VIRTUAL_EXERCISE_MODULE_ACCESSED: 'virtual-exercise-module-accessed',
} as const;

export const ANALYTICS_EVENT_LOCATIONS = {
  PORTAAL: 'portaal',
} as const;

export const ANALYTICS_EVENT_SUBLOCATIONS = {
  PORTAAL_BOOK_SWITCHER: 'portaal-book-switcher',
  PORTAAL_CATALOG: 'portaal-catalog',
  PORTAAL_CATEGORICAL_MATERIAL: 'portaal-categorical-material',
  PORTAAL_DASHBOARD: 'portaal-dashboard',
  PORTAAL_EXERCISE_BOOK: 'portaal-exercise-book',
  PORTAAL_EXERCISE_THEME: 'portaal-exercise-theme',
  PORTAAL_EXERCISE: 'portaal-exercise',
  PORTAAL_MATERIAL_APPS: 'portaal-material-apps',
  PORTAAL_MATERIAL: 'portaal-material',
  PORTAAL_MODULE_ASSIGNMENTS: 'portaal-module-assignments',
  PORTAAL_MODULE_DASHBOARD: 'portaal-module-dashboard',
  PORTAAL_MODULE_ASSIGNMENT_MATERIAL: 'portaal-module-assignment-material',
  PORTAAL_MODULE_SHARED_MATERIAL: 'portaal-module-shared-material',
  PORTAAL_MODULE_EXERCISE_MATERIAL: 'portaal-module-exercise-material',
  PORTAAL_MODULE_OTHER_MATERIAL: 'portaal-module-other-material',
  PORTAAL_MY_ASSIGNMENTS: 'portaal-my-assignments',
  PORTAAL_PINNED_MATERIAL: 'portaal-pinned-material',
  PORTAAL_RESULTS: 'portaal-results',
  PORTAAL_SEARCH: 'portaal-search',
  PORTAAL_STUDENT_ASSIGNMENTS: 'portaal-student-assignments',
  PORTAAL_SUBMODULE_SELECTION: 'portaal-submodule-selection',
  PORTAAL_SUPERMODULE_NAVIGATION: 'portaal-supermodule-navigation',
  PORTAAL_TEACHER_ASSIGNMENTS: 'portaal-teacher-assignments',
  PORTAAL_EXERCISE_MODULE_MATERIAL: 'portaal-exercise-module-material',
  PORTAAL_EXERCISE_MODULE_ASSIGNMENT_MATERIAL: 'portaal-exercise-module-assignment-material',
  PORTAAL_EXERCISE_MODULE_SHARED_MATERIAL: 'portaal-exercise-module-shared-material',
  PORTAAL_EXERCISE_MODULE_EXERCISE_MATERIAL: 'portaal-exercise-module-exercise-material',
  PORTAAL_EXERCISE_MODULE_OTHER_MATERIAL: 'portaal-exercise-module-other-material',
  PORTAAL_EXERCISE_MODULE_PINNED_MATERIAL: 'portaal-exercise-module-pinned-material',
  PORTAAL_VIRTUAL_EXERCISE_MODULE: 'portaal-virtual-exercise-module',
  PORTAAL_VIRTUAL_EXERCISE_MODULE_ASSIGNMENT_MATERIAL: 'portaal-virtual-exercise-module-assignment-material',
  PORTAAL_VIRTUAL_EXERCISE_MODULE_SHARED_MATERIAL: 'portaal-virtual-exercise-module-shared-material',
  PORTAAL_VIRTUAL_EXERCISE_MODULE_EXERCISE_MATERIAL: 'portaal-virtual-exercise-module-exercise-material',
} as const;

export type AnalyticsEventSubLocation = typeof ANALYTICS_EVENT_SUBLOCATIONS[keyof typeof ANALYTICS_EVENT_SUBLOCATIONS];
